export class NewRegistrationHighSchool {
  id?: number;
  highSchoolName!: string;
  fieldOfStudy!: string;
  educationLevelID?: number;
  city!: string;
  country!: string;
  startDate!: Date;
  endDate!: Date;
  candidateAttachment!: NewRegistrationAttachment;
  edit!: boolean;
  personalDataID?: number;
  attachmentID?: number;
  isAiParsed?: boolean;
}

export class NewRegistrationAttachment {
  url?: string;
  fileType?: string;
  type?: string;
  fileName!: string;
}

export class NewRegistrationPersonalInfo {
  id?: number;
  gender!: string;
  name!: string;
  surname!: string;
  title?: string;
  titleAfterName?: string;
  birthDate!: Date;
  email!: string;
  telephone!: string;
  // from confluesne?
  // nationality!: string;
  // status!: boolean;
  // experience!: number;
  streetName!: string;
  streetNumber!: string;
  zip!: number;
  city!: string;
  country!: string;
  aiMatching?: boolean;
}

export class NewRegistrationUniversity {
  id?: number;
  universityName!: string;
  fieldOfStudy!: string;
  educationLevelID?: number;
  city!: string;
  country!: string;
  startDate!: Date;
  current!: boolean;
  endDate!: Date | null;
  candidateAttachment!: NewRegistrationAttachment;
  edit!: boolean;
  personalDataID?: number;
  attachmentID?: number;
  isAiParsed?: boolean;
}
export class NewRegistrationProject {
  id?: number;
  title!: string;
  position!: string;
  duration!: string;
  country!: string;
  edit!: boolean;
  personalDataID?: number;
  isAiParsed?: boolean;
}

export class NewRegistrationLanguage {
  id?: number;
  language!: string;
  level!: string;
  edit!: boolean;
  personalDataID?: number;
  isAiParsed?: boolean;
}
export class NewRegistrationCourse {
  id?: number;
  courseName!: string;
  certificate!: boolean;
  endDate!: Date;
  specification!: string;
  edit!: boolean;
  personalDataID?: number;
  isAiParsed?: boolean;
}

export class NewRegistrationWorkExperience {
  id?: number;
  position!: string;
  employer!: string;
  city!: string;
  startDate!: Date;
  current!: boolean;
  endDate!: Date | null;
  country!: string;
  description!: string;
  edit!: boolean;
  personalDataID?: number;
  isAiParsed?: boolean;
}

export class NewRegistrationSkills {
  id?: number;
  skillName!: string;
  category?: string;
  level!: string;
  edit!: boolean;
  personalDataID?: number;
  isAiParsed?: boolean;
}
